var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDetailsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 3H8V5H6V3ZM9 10H8V6H5V7H6V10H5V11H9V10Z",
    fill: "#605E5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 14C10.8656 14 14 10.8656 14 7C14 3.13437 10.8656 0 7 0C3.13437 0 0 3.13437 0 7C0 10.8656 3.13437 14 7 14ZM7 1C10.3125 1 13 3.6875 13 7C13 10.3125 10.3125 13 7 13C3.6875 13 1 10.3125 1 7C1 3.6875 3.6875 1 7 1Z",
    fill: "#605E5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailsIcon);
export default __webpack_public_path__ + "static/media/DetailsIcon.f6e6bd89d0775315583bef544b06b4f1.svg";
export { ForwardRef as ReactComponent };